/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionPublishBotexamidQueryResponse,
  GetApiV1ExamRevisionPublishBotexamidPathParams,
  GetApiV1ExamRevisionPublishBotexamid400,
  GetApiV1ExamRevisionPublishBotexamid401,
  GetApiV1ExamRevisionPublishBotexamid404,
  GetApiV1ExamRevisionPublishBotexamid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionPublishBotexamid.ts";

function getGetApiV1ExamRevisionPublishBotexamidUrl(
  botExamId: GetApiV1ExamRevisionPublishBotexamidPathParams["botExamId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/revision/publish/${botExamId}` as const,
  };
  return res;
}

/**
 * @description Retorna os dados necessários para a tela de publicação de uma avaliação gerada por IA, incluindo as informações da prova (BotExam) e as opções de configuração para a publicação principal e, se aplicável, para a publicação da avaliação docente. **(Requer Authorization para autenticação)**
 * @summary Obter dados para publicação de avaliação gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/publish/:botExamId}
 */
export async function getApiV1ExamRevisionPublishBotexamid(
  botExamId: GetApiV1ExamRevisionPublishBotexamidPathParams["botExamId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionPublishBotexamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionPublishBotexamid400
      | GetApiV1ExamRevisionPublishBotexamid401
      | GetApiV1ExamRevisionPublishBotexamid404
      | GetApiV1ExamRevisionPublishBotexamid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionPublishBotexamidUrl(botExamId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
